/**
 * @enum {string}
 */
export const ResponseErrorCode = {
  TIMEOUT: 'ECONNABORTED',
};
